import React, { useContext } from 'react';
import classNames from 'classnames';

import { FormContext } from './FormContext';
import { FormProvider } from './FormProvider';

interface IProps {
  title?: string;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

export const FormFieldsContext = React.createContext({
  disabled: false,
});

function FormFields({ title, required, disabled, readonly, children }: IProps) {
  const formContext = useContext(FormContext);
  const formatConfigContext = useContext(FormProvider);
  const className = classNames('novoForm__fields', {
    'novoForm__fields--titled': title,
    'novoForm__fields--required': formatConfigContext.isShowingRequiredSymbol && required,
    'novoForm__fields--readonly': readonly,
  });
  const isDisabled = formContext.disabled || disabled || readonly;

  return (
    <FormFieldsContext.Provider value={{ disabled: isDisabled }}>
      <fieldset className={className} disabled={isDisabled}>
        {title && <legend className="novoForm__fields__title">{title}</legend>}
        {children}
      </fieldset>
    </FormFieldsContext.Provider>
  );
}

export default FormFields;
